import { Wizard } from '@/components/layout/Wizard';
import { WizardContainer } from '@/components/wm/WizardContainer';
import Plans from '@/pages/Plans';
import { OrganizationForm } from '@/pages/Signup/Content/Organization';
import { OrganizationTypeForm } from '@/pages/Signup/Content/OrganizationType';
import { SubmissionConfirmation } from '@/pages/Signup/Content/SubmissionConfirmation';
import { TermsForm } from '@/pages/Signup/Content/Terms';
import { UserForm } from '@/pages/Signup/Content/User';
import { apiRequest } from '@/utils/request';
import * as React from 'react';

const initialData = {
    firstName: '',
    lastName: '',
    email: '',
    telephone: '',
    organizationName: '',
    marketing: false,
    country: '',
    organizationType: '',
    acceptedTerms: false
};

const SignupPage = () => {
    const steps = [
        { Component: UserForm, title: i18next.t('signup.register_user'), description: i18next.t('signup.register_user_desc') },
        { Component: OrganizationForm, title: i18next.t('signup.register_organization'), description: i18next.t('signup.register_organization_desc') },
        { Component: OrganizationTypeForm, title: i18next.t('signup.type_of_organization'), description: i18next.t('signup.type_of_organization_desc') },
        { Component: () => <Plans organization={null}/>, title: i18next.t('signup.subscription_plan'), description: i18next.t('signup.subscription_plan_desc') },
        { Component: TermsForm, title: i18next.t('signup.terms_and_conditions'), description: i18next.t('signup.terms_and_conditions_desc') }
    ];

    const successComponent = { Component: SubmissionConfirmation, title: i18next.t('signup.well_done'), description: i18next.t('signup.you_are_registered') };

    const handleBackToLogin = () => {
        Backbone.history.navigate('login', { trigger: true, replace: true });
    };

    const handleSubmit = async data => {
        try {
            const submitData = {
                country: data.country,
                email: data.email,
                marketing: data.marketing,
                name: `${data.firstName} ${data.lastName}`,
                organization_name: data.organizationName,
                organization_type: data.organizationType,
                telephone: data.telephone
            };
            const response = await apiRequest('/leads', 'POST', submitData);
            return response;
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize?.() || i18next.t('alert_boxes.error_occurred');
            throw new Error(errorMessage); // Throwing it so Wizard can catch
        }
    };

    return (
        <div className="tw-relative tw-w-screen tw-h-screen tw-overflow-hidden">
            {/* Top background */}
            <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-1/2 tw-bg-[url('/images/placeholder_wide.webp')] tw-bg-cover tw-bg-center tw-bg-no-repeat"/>

            {/* Bottom background */}
            <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-1/2 tw-bg-backgroundGrey"/>

            {/* Logo */}
            <div className="tw-absolute tw-left-1/2 tw-top-[calc(15%-6rem)] tw-transform tw--translate-x-1/2 tw-w-full tw-max-w-[80vw] tw-z-[100]">
                <img alt="Logo" className="tw-h-20" src="/images/wisemetering/negative-logo-horizontal.png"/>
            </div>

            <WizardContainer>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    onClose={() => Backbone.history.navigate('/login', { trigger: true })}
                    steps={steps}
                    successComponent={successComponent}
                />
            </WizardContainer>

            <div className="tw-absolute tw-left-1/2 tw-top-[calc(85%+1rem)] tw-transform tw--translate-x-1/2 tw-w-full tw-max-w-[80vw] tw-text-center">
                <p>{i18next.t('signup.already_have_account')}
                    <a
                        className={`tw-text-primary hover:tw-underline tw-cursor-pointer tw-font-bold tw-text-md tw-ml-2`}
                        onClick={handleBackToLogin}
                    >
                        {i18next.t('signup.login_here')}
                    </a>
                </p>
            </div>
        </div>
    );
};

export default SignupPage;
